import { Markdown } from "@holigral/shared/ui"
import { Prose } from "@holigral/shared/ui/components"
import type { HeadingBlock, ReaderDocument } from "./model"
import { Matrix } from "@/matrix"
import type { ResultMatrix } from "@/matrix"

type Props = {
  readonly document: ReaderDocument
  readonly matrix: ResultMatrix
}

/**
 * A published evaluation as its template lays it out. The page already has
 * an h1, so the document's title is an h2.
 */
export default function EvaluationDocument({ document, matrix }: Props) {
  return (
    // The container the matrix shrinks its cells to fit
    <div data-reading className="@container flex flex-col gap-4">
      {document.map((block, index) => {
        switch (block.type) {
          case "heading":
            // eslint-disable-next-line @eslint-react/no-array-index-key -- the document is static, and its blocks have no identity of their own
            return <Heading key={index} block={block} />
          case "markdown":
            // eslint-disable-next-line @eslint-react/no-array-index-key -- the document is static, and its blocks have no identity of their own
            return <Markdown key={index}>{block.text}</Markdown>
          case "matrix":
            // eslint-disable-next-line @eslint-react/no-array-index-key -- the document is static, and its blocks have no identity of their own
            return <Matrix key={index} matrix={matrix} />
        }
      })}
    </div>
  )
}

const TAGS = { 1: "h2", 2: "h3", 3: "h4" } as const

function Heading({ block }: { readonly block: HeadingBlock }) {
  const Tag = TAGS[block.level]

  return (
    <Prose className={block.level === 1 ? undefined : "mt-4"}>
      <Tag>{block.text}</Tag>
    </Prose>
  )
}
